import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {Planning, PlanningQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const PLANNING_URL = `${API_URL}/planning`
const GET_PLANNING_URL = `${API_URL}/planning`
const WAGES_RUL = `${API_URL}/wages/in-out`
const WAGES_SALARIES_RUL = `${API_URL}/wages`
const WAGES_HOURS_URL = `${API_URL}/wages/hours`

const getPlannings = (query: string): Promise<PlanningQueryResponse> => {
  return axios
    .get(`${GET_PLANNING_URL}?${query}`)
    .then((d: AxiosResponse<PlanningQueryResponse>) => d.data)
}

const duplicatePlanning = (payload: any): any => {
  return axios
    .post(`${GET_PLANNING_URL}/duplicate`, payload)
    .then((d: AxiosResponse<PlanningQueryResponse>) => d.data)
}

const getIoFile = (date: string, format: string): any => {
  return axios
    .get(`${WAGES_RUL}?period=${date}&format=${format}`)
    .then((d: AxiosResponse<PlanningQueryResponse>) => d.data)
      .catch((d: any) => d.response)
}

const getSalaireFile = (date: string, format: string): any => {
  return axios
    .get(`${WAGES_SALARIES_RUL}?period=${date}&format=${format}`)
    .then((d: AxiosResponse<PlanningQueryResponse>) => d.data)
    .catch((d: any) => d.response)
}

const getWagesHours = (period: string): Promise<Array<any>> => {
  return axios.get(`${WAGES_HOURS_URL}?period=${period}`).then((d: AxiosResponse<any>) => {
    return d.data?.data ?? []
  })
}

const getPlanningsArray = (period: string, location: any): Promise<Array<Planning>> => {
  return axios.get(`${GET_PLANNING_URL}?period=${period}&location=${location?._id?.toString()}`).then((d: AxiosResponse<any>) => {
    return d.data.data
  })
}

const getPlanningsAvailable = (period: string): Promise<any> => {
  return axios.get(`${GET_PLANNING_URL}/state?period=${period}`).then((d: AxiosResponse<any>) => {
    return d.data.data
  })
}


const updatePlanningsAvailable = (period: string, visible = true): Promise<any> => {
  return axios.put(`${GET_PLANNING_URL}/state`, {
    period, visible
  }).then((d: AxiosResponse<any>) => {
    return d.data.data
  })
}

const getPlanningById = (id: ID): Promise<Planning | undefined> => {
  return axios
    .get(`${PLANNING_URL}/${id}`)
    .then((response: AxiosResponse<Response<Planning>>) => response.data)
    .then((response: Response<Planning>) => response.data)
}

const createPlanning = (planning: Planning): Promise<Array<Planning>> => {
  const payload: any = planning
  payload.collaborator = planning?.collaborator?._id || ''
  return axios.post(PLANNING_URL, payload).then((d: AxiosResponse<any>) => {
    return d.data.data
  })
}

const updatePlanning = (planning: Planning): Promise<Planning | undefined> => {
  return axios
    .put(`${PLANNING_URL}/${planning._id}`, planning)
    .then((response: AxiosResponse<Response<Planning>>) => response.data)
    .then((response: Response<Planning>) => response.data)
}

const deletePlanning = (planning?: Planning): Promise<Array<Planning>> => {
  return axios.delete(`${PLANNING_URL}/${planning?._id}?force=true`).then((d: AxiosResponse<any>) => {
    return d.data.data
  })
}

const deleteSelectedPlannings = (planningIds: Array<ID>): Promise<void> => {
  const requests = planningIds.map((id) => axios.delete(`${PLANNING_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getPlannings,
  getPlanningsArray,
  deletePlanning,
  deleteSelectedPlannings,
  getPlanningById,
  createPlanning,
  updatePlanning,
  duplicatePlanning,
  getIoFile,
  getSalaireFile,
  getWagesHours,
  getPlanningsAvailable,
  updatePlanningsAvailable
}
